export const messages = {
	loading: "Buscando órdenes de pago por Nro siniestro...",
	noResults: (nroSiniestro) => `No se encontraron órdenes de pago para el nro de siniestro ${nroSiniestro}`,
	results: (nroSiniestro, cantResults) => `Se encontraron ${cantResults} órdenes de pago para el nro de siniestro ${nroSiniestro}`,
}
